'use client';

import React, { useState } from 'react';

import Image from 'next/image';

import privacyChoiceIcon from '@/assets/icons/privacy-preferences-icon.svg';
import { useAuthContext } from '@/components/Providers/AuthProvider';

import NewPrivacyPreferenceModal from './NewPrivacyPreferenceModal';

interface FooterPrivacyPreferenceLinkProps {
  href: string;
}

const FooterPrivacyPreferenceLink: React.FC<FooterPrivacyPreferenceLinkProps> = ({ href }) => {
  const { isLoggedIn } = useAuthContext();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (isLoggedIn) {
    return (
      <a
        href={href}
        className="v2-font-sweet-sans-pro-light v2-underline v2-flex v2-items-center v2-gap-4 text-white hover:opacity-70 hover:transition-opacity"
      >
        <Image src={privacyChoiceIcon} alt="" /> Your Privacy Choices
      </a>
    );
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setIsModalOpen(true)}
        className="v2-font-sweet-sans-pro-light v2-underline v2-bg-transparent v2-border-0 v2-flex v2-items-center v2-gap-4 text-white  hover:opacity-70 hover:transition-opacity"
      >
        <Image src={privacyChoiceIcon} alt="" /> Your Privacy Choices
      </button>
      <NewPrivacyPreferenceModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default FooterPrivacyPreferenceLink;
